import COMMUNICATION_TEMPLATE_ACTION from '~/server_shared/generated-types/COMMUNICATION_TEMPLATE_ACTION';

type RecipientKeys = keyof typeof COMMUNICATION_TEMPLATE_ACTION.RECIPIENT;
type SenderKeys = keyof typeof COMMUNICATION_TEMPLATE_ACTION.SENDER_TYPE;

export const recipientBaseKey = COMMUNICATION_TEMPLATE_ACTION.RECIPIENT;
export const senderBaseKey = COMMUNICATION_TEMPLATE_ACTION.SENDER_TYPE;

// BROKER is included for both scopes; the BE `recipient_options` endpoint is the
// runtime gate (drops BROKER when the broker `ContactRole` is disabled). The
// scope lists stay as the static "is this recipient meaningful for this scope"
// allowlist that the picker intersects with the BE response.
export const recipientByScope: {
  claim: RecipientKeys[];
  exposure: RecipientKeys[];
} = {
  claim: ['INSURED', 'PREFERRED_CONTACT', 'BROKER', 'REPORTER'],
  exposure: ['INSURED', 'CLAIMANT', 'PREFERRED_CONTACT', 'ATTORNEY', 'BROKER', 'REPORTER'],
};

export const senderByScope: {
  claim: SenderKeys[];
  exposure: SenderKeys[];
} = {
  claim: ['CLAIM_OWNER', 'CLAIM_OWNER_SUPERVISOR'],
  exposure: ['CLAIM_OWNER', 'EXPOSURE_OWNER', 'CLAIM_OWNER_SUPERVISOR', 'EXPOSURE_OWNER_SUPERVISOR'],
};
